import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Icon } from "@/lib/icons";

// Stacked, dismissible in-app banners (dues grace reminder, targeted messages,
// event announcements). Height is capped so many banners never overtake the screen.
export default function BannerStack() {
  const [banners, setBanners] = useState([]);
  const load = useCallback(() => {
    api.get("/banners").then((r) => setBanners(r.data.banners || [])).catch(() => setBanners([]));
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onRefresh = () => load();
    window.addEventListener("rca:banners-refresh", onRefresh);
    return () => { clearInterval(t); window.removeEventListener("rca:banners-refresh", onRefresh); };
  }, [load]);

  const dismiss = async (id) => {
    setBanners((b) => b.filter((x) => x.id !== id));
    try { await api.post(`/banners/${encodeURIComponent(id)}/dismiss`); } catch (e) { /* ignore */ }
  };
  if (banners.length === 0) return null;

  return (
    <div data-testid="banner-stack" className="fixed top-2 left-1/2 -translate-x-1/2 z-[90] w-[min(680px,94vw)] max-h-[40vh] overflow-y-auto space-y-2 pointer-events-none">
      {banners.map((b) => {
        const warn = b.kind === "warning";
        return (
          <div key={b.id} data-testid={`banner-${b.id}`}
            className={`pointer-events-auto rounded-xl shadow-lg border px-4 py-3 flex items-start gap-3 ${warn ? "bg-gold/95 border-gold text-ink" : "bg-cream/98 border-ink/15 text-ink"}`}>
            <Icon name={warn ? "AlertTriangle" : "Megaphone"} className={`w-5 h-5 mt-0.5 shrink-0 ${warn ? "text-maroon" : "text-dark-olive"}`} />
            <div className="min-w-0 flex-1">
              <div className="text-[15px] font-semibold">{b.title}</div>
              {b.text && <div className="text-[13px] text-ink/70 whitespace-pre-wrap">{b.text}</div>}
              {b.from && <div className="text-[12px] text-ink/50 mt-0.5">From {b.from}</div>}
            </div>
            <button data-testid={`banner-dismiss-${b.id}`} onClick={() => dismiss(b.id)} aria-label="Dismiss" className="shrink-0 text-ink/40 hover:text-maroon p-1">
              <Icon name="X" className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
